(() => {
  'use strict';
  const script = document.currentScript;
  const enabled = script?.dataset.meBackendEnabled === 'true';
  const base = script?.dataset.meBackendBase || '/apps/moments-etched';
  if (!enabled) return;

  const clean = value => String(value ?? '').trim();
  const highTrust = form => Boolean(form.matches('[data-me-b2b-form],[data-me-wed-form],[data-me-wholesale-form],[data-me-secure-form="verified"]') || form.closest('[data-me-wholesale-portal]') || /business|wedding|wholesale|custom/i.test(location.pathname));
  const findPhone = form => form.querySelector('input[type="tel"],input[name*="phone" i]');
  const findValue = (form, patterns) => {
    for (const pattern of patterns) {
      const el = form.querySelector(pattern);
      if (el && clean(el.value)) return clean(el.value);
    }
    return '';
  };
  const json = async (path, body) => {
    const response = await fetch(`${base}${path}`, { method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify(body), credentials: 'same-origin' });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.error || 'The secure service is temporarily unavailable.');
    return data;
  };
  const collect = form => {
    const values = {};
    new FormData(form).forEach((value, key) => { if (typeof value === 'string' && clean(value)) values[key] = clean(value); });
    const params = new URLSearchParams(location.search);
    const totalText = params.get('summary')?.match(/Estimated\s+\$([\d,.]+)/i)?.[1];
    const totalCents = totalText ? Math.round(Number(totalText.replace(/,/g,'')) * 100) : undefined;
    const quantityText = params.get('summary')?.match(/\|\s*(\d+)\s+pieces?/i)?.[1];
    return {
      organization: findValue(form, ['[name*="organization" i]','[name*="company" i]','[data-me-portal-field="organization"]']),
      contactName: findValue(form, ['[name*="contact" i]','[name*="name" i]','[data-me-portal-field="contact"]']),
      email: findValue(form, ['input[type="email"]']),
      phone: findValue(form, ['input[type="tel"]','input[name*="phone" i]']),
      phoneVerificationToken: form.dataset.mePhoneToken || '',
      needBy: findValue(form, ['input[type="date"]','[name*="need" i]']),
      taxExempt: Boolean(form.querySelector('[name*="tax" i]:checked')),
      poNumber: findValue(form, ['[name*="po" i]']),
      notes: findValue(form, ['textarea']),
      summary: { fields: values, quote: params.get('quote'), quoteSummary: params.get('summary') },
      estimatedTotalCents: Number.isFinite(totalCents) ? totalCents : undefined,
      currency: 'USD',
      quantity: Number(quantityText || 0),
      rush: false,
      sourceUrl: location.href,
      honeypot: findValue(form, ['[data-me-honeypot]','[name="company_website"]'])
    };
  };

  const installVerify = form => {
    if (!highTrust(form) || form.dataset.meVerifyReady === 'true') return;
    const phone = findPhone(form);
    if (!phone) return;
    form.dataset.meVerifyReady = 'true';
    const box = document.createElement('div');
    box.className = 'me-verify';
    box.innerHTML = '<strong>Verify your phone number</strong><p class="me-verify__status" aria-live="polite">A one-time code is required before this request can be submitted.</p><div class="me-verify__row"><button type="button" data-me-send-code>Send verification code</button><input type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="10" placeholder="Verification code" data-me-code hidden><button type="button" data-me-check-code hidden>Verify code</button></div>';
    phone.insertAdjacentElement('afterend', box);
    const status = box.querySelector('.me-verify__status');
    const send = box.querySelector('[data-me-send-code]');
    const code = box.querySelector('[data-me-code]');
    const check = box.querySelector('[data-me-check-code]');
    const message = (text, type='') => { status.textContent = text; status.className = `me-verify__status ${type}`; };
    send.addEventListener('click', async () => {
      send.disabled = true;
      try { await json('/api/verify/start', { phone: phone.value }); code.hidden = false; check.hidden = false; message('Verification code sent. It expires shortly.'); code.focus(); }
      catch (error) { message(error.message, 'is-error'); }
      finally { window.setTimeout(() => { send.disabled = false; }, 15000); }
    });
    check.addEventListener('click', async () => {
      check.disabled = true;
      try { const result = await json('/api/verify/check', { phone: phone.value, code: code.value }); form.dataset.mePhoneToken = result.token; phone.readOnly = true; send.hidden = true; code.hidden = true; check.hidden = true; message('Phone verified.', 'is-success'); }
      catch (error) { message(error.message, 'is-error'); }
      finally { check.disabled = false; }
    });
    phone.addEventListener('input', () => { if (form.dataset.mePhoneToken) { delete form.dataset.mePhoneToken; phone.readOnly = false; message('Phone number changed. Please verify it again.', 'is-error'); send.hidden = false; } });

    form.addEventListener('submit', async event => {
      if (form.dataset.meBackendSubmitting === 'true') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!form.dataset.mePhoneToken) { message('Verify your phone number before submitting.', 'is-error'); box.scrollIntoView({behavior:'smooth',block:'center'}); return; }
      const submit = form.querySelector('[type="submit"]');
      if (submit) submit.disabled = true;
      try {
        const result = await json('/api/requests', collect(form));
        form.dataset.meBackendSubmitting = 'true';
        const hidden = document.createElement('input'); hidden.type = 'hidden'; hidden.name = 'contact[Wholesale request number]'; hidden.value = result.requestNumber; form.appendChild(hidden);
        form.requestSubmit();
      } catch (error) {
        message(error.message || 'Your request could not be saved. Please try again.', 'is-error');
        if (submit) submit.disabled = false;
      }
    }, true);
  };

  const scan = root => root.querySelectorAll?.('form').forEach(installVerify);
  document.addEventListener('DOMContentLoaded', () => scan(document));
  new MutationObserver(records => records.forEach(r => r.addedNodes.forEach(n => { if (n.nodeType === 1) { if (n.matches?.('form')) installVerify(n); scan(n); } }))).observe(document.documentElement, {childList:true,subtree:true});
})();
